import 'bootstrap';
import Theme from './theme';

document.addEventListener('DOMContentLoaded', () => window.theme = new Theme(document));



// WEBPACK FOOTER //
// ./resources/scripts/app.js